import errors from './errors/index.js';
import translation from './translation/index.js';
const tr_tr = {
    translation,
    errors,
};
export default Object.freeze(tr_tr);
